import React, { useRef, useState } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import Button from 'components/base/Button';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';
import VendorReviewModal from 'components/modals/VendorReviewModal';
import { useNavigate } from 'react-router-dom';

const RateVendorButton = ({ vendorId }: { vendorId: string | null }) => {
  const { user } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const [showPopover, setShowPopover] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const targetRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    if (!user || user.role !== 'customer') {
      setShowPopover(true);
      setTimeout(() => setShowPopover(false), 4000); // Auto close popover
    } else {
      setShowModal(true);
    }
  };

  const renderPopoverContent = () => {
    if (!user) {
      return (
        <>
          <p className="mb-2">please login as customer.</p>
          <Button
            variant="primary"
            className="w-100"
            onClick={() => navigate('/sign-in')}
          >
            Go to Login
          </Button>
        </>
      );
    } else if (user.role === 'vendor') {
      return <p className="mb-0">Only customers can rate vendors.</p>;
    }
    return null;
  };

  return (
    <>
      <div ref={targetRef}>
        <Button
          variant="primary"
          className="rounded-pill px-4 py-2 fw-semibold shadow-sm transition-all hover:scale-105"
          onClick={handleClick}
        >
          Rate this Vendor
        </Button>
      </div>

      <Overlay
        target={targetRef.current}
        show={showPopover}
        placement="right"
        rootClose
        onHide={() => setShowPopover(false)}
      >
        <Popover id="rate-vendor-popover" className="shadow rounded border-0">
          <Popover.Body
            className="text-center text-dark py-3 px-4"
            style={{ maxWidth: '250px' }}
          >
            {renderPopoverContent()}
          </Popover.Body>
        </Popover>
      </Overlay>

      <VendorReviewModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        vendorId={vendorId}
        userId={user?._id ?? null}
      />
    </>
  );
};

export default RateVendorButton;
